module.exports = {
      id: "google-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#google",
      toString: function () {
        return this.url;
      }
    }